import React, { FC } from 'react';
import DealerLogin from '../dealerLogin';
import MarketSelector from '../marketSelector';
import LanguageSelector from '../languageSelector';
import { ActionSectionModel } from './models/actionSection.models';
import { TActionSectionProps } from './types/actionSection.types';
import BecomeDealer from '../dealerRequest';
import useMediaQuery from '../../../../hooks/useMediaQuery';
import breakpoints from '../../../../constants/breakpoints.constants';
import { googleMarketLangClickEvent } from '../../../../utils/analytics';
import { languageSelector, marketSelector } from '../../../../constants/analytics.constants';
import './styles.scss';

const ActionSection: FC<TActionSectionProps> = (props) => {
  const model = new ActionSectionModel(props);
  const analytics = props?.sitecoreContext?.analytics;
  let showLanguageSelector = false;

  if (model?.languageSelector?.list && model?.languageSelector?.list?.length > 1) {
    showLanguageSelector = true;
  }

  const isTblp = useMediaQuery(`(min-width: ${breakpoints['tbl-p']}px)`);

  if (props.isBelow) {
    if (isTblp) {
      return null;
    }

    return (
      <div className="footer-action-section">
        <DealerLogin fields={model?.dealerLoginLink} />
        <BecomeDealer fields={model?.dealerRequestLink} />
      </div>
    );
  }

  return (
    <div className="footer-action-section">
      <MarketSelector
        fields={model?.marketSelector}
        onclick={() => {
          googleMarketLangClickEvent(marketSelector, analytics?.market, analytics?.language);
        }}
      />
      {showLanguageSelector && (
        <LanguageSelector
          fields={model?.languageSelector}
          onclick={() => {
            googleMarketLangClickEvent(languageSelector, analytics?.market, analytics?.language);
          }}
        />
      )}
      {isTblp && (
        <>
          <DealerLogin fields={model?.dealerLoginLink} />
          <BecomeDealer fields={model?.dealerRequestLink} />
        </>
      )}
    </div>
  );
};

export default ActionSection;
